import React from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";

const Container = styled.div`
    user-select: none;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    text-decoration: none;
    font-family: urdu;
    font-weight: 500;
`;

const Button = styled.div<{ selected: boolean }>`
    padding: 3px 15px;
    font-size: 18px;
    color: ${(p) => (p.selected ? "#000" : "#000")};
    background-color: ${(p) => (p.selected ? "#edeced" : "#fff")};
    min-width: 75px;
    text-align: center;

    &:first-of-type {
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border: 1px solid #ccc;
    }

    &:last-of-type {
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;
        border-left: 1px solid #ccc;
        border-top: 1px solid #ccc;
        border-bottom: 1px solid #ccc;
    }
`;

export interface SplitButtonProps {
    values: Array<{ label: string; value: string }>;
    selected: string;
    onChange: (value: string) => void;
}

export function SplitButton({ values, selected, onChange }: SplitButtonProps) {
    return (
        <Container>
            {values.map(({ label, value }) => (
                <Button
                    key={`split-btn-${value}`}
                    selected={value === selected}
                    onClick={() => {
                        const v = values.find((v) => v.value !== selected);
                        if (v) {
                            onChange(v.value);
                        }
                    }}
                >
                    <FormattedMessage id={label} />
                </Button>
            ))}
        </Container>
    );
}
